/* eslint-disable camelcase */
// import basic from './basic';
import teacher_pro from "./teacher_pro";
import school_and_district from "./school_and_district";

const plans = {
  // basic,
  teacher_pro,
  school_and_district,
};

export default plans;
